export default __webpack_public_path__ + "static/media/ic_close.de655f06.svg";